var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zap",
    clipPath: "url(#clip0_0_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.02178 8.07747C2.11527 8.13616 2.22348 8.16711 2.33386 8.16674H6.41673C6.51108 8.16643 6.60409 8.18902 6.68779 8.23256C6.77149 8.27611 6.84338 8.33931 6.89729 8.41675C6.9512 8.49419 6.98553 8.58356 6.99732 8.67718C7.00912 8.7708 6.99803 8.86589 6.965 8.95428L5.84513 12.4662C5.82759 12.53 5.83225 12.5978 5.85835 12.6586C5.88445 12.7194 5.93044 12.7695 5.98877 12.8007C6.0471 12.8319 6.11431 12.8424 6.17935 12.8303C6.2444 12.8183 6.30343 12.7845 6.34674 12.7345L12.1211 6.78415C12.1906 6.69842 12.2344 6.59472 12.2474 6.48509C12.2603 6.37545 12.2419 6.2644 12.1943 6.16482C12.1466 6.06524 12.0717 5.98122 11.9782 5.92253C11.8847 5.86384 11.7765 5.83289 11.6661 5.83326H7.58327C7.48892 5.83357 7.39591 5.81098 7.31221 5.76744C7.22851 5.72389 7.15662 5.66069 7.10271 5.58325C7.0488 5.50581 7.01447 5.41644 7.00268 5.32282C6.99088 5.2292 7.00198 5.13411 7.035 5.04572L8.15487 1.53384C8.17241 1.47005 8.16775 1.40219 8.14165 1.34139C8.11555 1.2806 8.06956 1.23049 8.01123 1.19928C7.9529 1.16808 7.88569 1.15763 7.82065 1.16966C7.7556 1.18169 7.69658 1.21549 7.65326 1.26549L1.87891 7.21585C1.80937 7.30158 1.76558 7.40528 1.75263 7.51492C1.73968 7.62455 1.75809 7.7356 1.80574 7.83518C1.85338 7.93476 1.9283 8.01878 2.02178 8.07747Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.971b78aea0e1e2c84ffaa7c6527a8b25.svg";
export { ForwardRef as ReactComponent };